import { winTypes } from '../enums/winPopupTypes';
import { winBarStore } from '../store/winBarStore';

export const getWinPopupType = () => {
  const odd = winBarStore.spinResultOdd;
  if (odd >= 500) return winTypes.EPIC;
  if (odd >= 200) return winTypes.SUPER;
  if (odd >= 50) return winTypes.MEGA;
  if (odd >= 15) return winTypes.BIG;
  if (odd) return winTypes.STANDARD;
  return winTypes.NONE;
};

export const MIN_BIG_WIN_POPUPS_ODD = 15;
